exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntd[data-v-7c4e5248] {\n    text-align: center;\n    vertical-align: middle;\n}\n.v-btn[data-v-7c4e5248]:hover:before {\n    background-color: transparent;\n}\n.v-btn[data-v-7c4e5248]:hover:after {\n    background-color: transparent;\n}\n\n", ""]);
